(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxury-scent-profile"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vayu-scent-profile')) {
    customElements.define('vayu-scent-profile', class extends HTMLElement {
      #request = 0;

      connectedCallback() {
        document.addEventListener('shopify:product:select', this.#onSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:product:select', this.#onSelect);
        this.#request++;
      }

      #onSelect = (event) => {
        if (!(event.target instanceof Element)) return;
        const picker = event.target.closest('variant-picker');
        if (!picker || picker.closest('product-card, dialog, quick-add-component')) return;
        if (picker.dataset.productId !== this.dataset.productId || !event.promise) return;
        const request = ++this.#request;
        this.setAttribute('aria-busy', 'true');

        event.promise.then(({ detail }) => {
          if (request !== this.#request || !this.isConnected || !detail?.html) return;
          const updated = Array.from(detail.html.querySelectorAll('vayu-scent-profile')).find(
            (profile) => profile.dataset.sectionId === this.dataset.sectionId
              && profile.dataset.productId === this.dataset.productId
          );
          if (updated) this.replaceChildren(...Array.from(updated.childNodes, (node) => node.cloneNode(true)));
        }).catch(() => {}).finally(() => {
          if (request === this.#request) this.removeAttribute('aria-busy');
        });
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
